import React from 'react'
import { Row, Col } from "antd"
import { useMediaQuery } from "react-responsive"
import HowItWorksItem from './components/HowItWorksItem'
import connectImg from "images/v2/icon_layer.svg"
import syncImg from "images/v2/icon_link.svg"
import generateImg from "images/v2/icon_page.svg"
import deliverImg from "images/v2/icon_mail.svg"


const HowItWorksSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  const dataItems = [
    {
      image: connectImg,
      description: "Sujungiamos ETSY ir Alsendo paskyros"
    },
    {
      image: syncImg,
      description: "Sinchronizuojami ETSY užsakymai"
    },
    {
      image: generateImg,
      description: "Sugeneruojami siuntos, muitinės dokumentai"
    },
    {
      image: deliverImg,
      description: "Siuntos siunčiamos ETSY pirkėjams"
    }
  ];

  return (
    <>
      <Row
        gutter={{ lg: 16 }}
        align="middle"
        style={{
          marginTop: isMobileScreen ? "10px" : "10px",
          textAlign: isMobileScreen ? "left" : "center",
          backgroundColor: "#F7F7F7",
          paddingTop: "50px",
          paddingBottom: "60px",
        }}
      >
        <Col
          span={24}
          style={{
            marginBottom: "15px"
          }}
        >
          <div className="section-title about-title" style={{
            marginTop: isMobileScreen ? "" : "50px",
            marginBottom: isMobileScreen ? "" : "15px",
            paddingLeft: isMobileScreen ? "15px" : "",
            paddingRight: isMobileScreen ? "15px" : "",
            textAlign: "center"
          }}>
            {"Kaip tai veikia?"}
          </div>
        </Col>

        <div
          style={
            {
              display: "flex",
              justifyContent: "center",
              width: "100%",
              padding: isMobileScreen ? "15px 15px" : "",
              marginBottom: isMobileScreen ? "" : "50px"
            }
          }
        >
          <Row gutter={[32, 10]} style={{ maxWidth: 1200 }}>
            {
              dataItems.map((item) => {
                return (
                  <HowItWorksItem dataItem={item} />
                )
              })
            }
          </Row>
        </div>
      </Row>
    </>
  )
}

export default HowItWorksSection
